export const cepMask = (cep?: string | null) => {
  if (!cep) return ''

  // Remove todos os caracteres não numéricos
  const cepLimpo = cep.replace(/\D/g, '')

  // Aplica a máscara conforme a quantidade de dígitos inseridos
  if (cepLimpo.length <= 5) {
    return cepLimpo
  } else if (cepLimpo.length <= 8) {
    return cepLimpo.replace(/^(\d{5})(\d{0,3})/, '$1-$2')
  } else {
    return cepLimpo
  }
}
